import {
  Box,
  Chip,
  Link,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material"
import { formatDateTime } from "app/date"
import { DeploymentStatus } from "../../pipelines/validations"
import getPipelineName from "../../pipelines/services/getPipelineName"
import { DeploymentGroupProps } from "./DeploymentGroupProps"
import { capitalize, getChipColor } from "../utils"
import FailReason from "./FailReason"

export const DeploymentGroup = (props: DeploymentGroupProps) => {
  const { date, deployments } = props

  return (
    <Box sx={{ mb: 3 }}>
      <Typography variant="h5" sx={{ mb: 2 }}>
        {date}
      </Typography>
      <TableContainer component={Paper}>
        <Table size="small">
          <TableHead>
            <TableRow>
              <TableCell>Time</TableCell>
              <TableCell>Pipeline</TableCell>
              <TableCell align="center">Deployment Status</TableCell>
              <TableCell>Fail Reason</TableCell>
              <TableCell align="center">User</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {deployments.map((deployment) => (
              <TableRow key={deployment.id}>
                <TableCell>{formatDateTime(deployment.createdAt)}</TableCell>
                <TableCell>
                  <Link href={`/pipelines/${deployment.pipeline.id}/edit`}>
                    {getPipelineName(deployment.pipeline)}
                  </Link>
                </TableCell>
                <TableCell align="center">
                  <Chip
                    label={capitalize(deployment.status)}
                    color={getChipColor(deployment.status as DeploymentStatus)}
                  />
                </TableCell>
                <TableCell>
                  <FailReason deployment={deployment} />
                </TableCell>
                <TableCell align="center">{deployment.user?.name ?? "n/a"}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  )
}
